<!--
 * @Description: 学生惩处 详情
 * @Author: PF
 * @Date: 2023-01-05 15:15:19
 * @LastEditors: PF
 * @LastEditTime: 2025-05-23 14:00:11
 * @FilePath: \ZHXY_VUE3.0\src\pages\xuesheng\views\jiangzhudaiguanli\xueshengchengchu\seePopup.vue
-->
<template>
  <div>
    <el-dialog class="w800 h600" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon"><Document /></el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon><Close /></el-icon>
          </el-button>
        </div>
      </template>
        <el-descriptions :column="4" border>
          <el-descriptions-item label="学期" label-align="right" align="left" width="120px" span="2">{{ruleForm.xqmc}}</el-descriptions-item>
          <el-descriptions-item label="班级" label-align="right" align="left" width="120px" span="2">{{ruleForm.bjmc}}</el-descriptions-item>
          <el-descriptions-item label="班主任" label-align="right" align="left" span="2">{{ruleForm.bzrxm}}</el-descriptions-item>
          <el-descriptions-item label="学生" label-align="right" align="left" span="2">{{ruleForm.xsxm}}</el-descriptions-item>
          <el-descriptions-item label="违纪日期" label-align="right" align="left" span="2">{{ruleForm.wjrq}}</el-descriptions-item>
          <el-descriptions-item label="违纪类别" label-align="right" align="left" span="2">{{ruleForm.wjlbbt}}</el-descriptions-item>
          <el-descriptions-item label="违纪简况" label-align="right" align="left" span="4">{{ruleForm.wjjk}}</el-descriptions-item>
          <el-descriptions-item label="处分名称" label-align="right" align="left" span="2">{{ruleForm.cfmcbt}}</el-descriptions-item>
          <el-descriptions-item label="处分日期" label-align="right" align="left" span="2">{{ruleForm.cfrq}}</el-descriptions-item>
          <el-descriptions-item label="处分文号" label-align="right" align="left" span="2">{{ruleForm.cfwh}}</el-descriptions-item>
          <el-descriptions-item label="处分撤销日期" label-align="right" align="left" span="2">{{ruleForm.cfcxrq}}</el-descriptions-item>
          <el-descriptions-item label="处分撤销文号" label-align="right" align="left" span="4">{{ruleForm.cfcxwh}}</el-descriptions-item>
          <el-descriptions-item label="处分原因" label-align="right" align="left" span="4">{{ruleForm.cfyy}}</el-descriptions-item>
        </el-descriptions>
        <template #footer>
          <div class="dialog-footer">
            <div></div>
            <div class="footer_but">
              <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
            </div>
          </div>
        </template>
      </el-dialog>
    </div>
  </template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'
const props = defineProps({ openDetail: { type: Boolean, required: true }, row: { type: Object, required: false } })
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/xuesheng/xueshengchengchu/' + props.row.id,
        ruleForm
      })
    }
  }, { deep: true, immediate: true })
</script>
